import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-581c952e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-span-2 dropdownProduct__figure" }
const _hoisted_2 = {
  key: 0,
  class: "dropdownProduct__placeholder"
}
const _hoisted_3 = ["alt", "src"]
const _hoisted_4 = { class: "col-span-9" }
const _hoisted_5 = { class: "align-vertical-center dropdownProduct__iconWrap" }
const _hoisted_6 = {
  key: 0,
  class: "theme-light theme-light--7 p-5"
}

import { ref, watch } from 'vue';
import { ComplexDownload, DownloadListResponse, SearchData, SimpleDownload } from '@/types';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import configHelper from '../../helpers/configHelper';
import { useFetch } from '../../hooks';
import ArticleDetails from '../molecules/ArticleDetails.vue';
import AccessoryDetails from '../molecules/AccessoryDetails.vue';
import ResultTable from './ResultTable.vue';
import { useNotifications } from '../../hooks/useNotifications';
import Spinner from '../atoms/Spinner.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
  product: SearchData;
}

const route = useRoute();
const { fetchApi, errorMessage } = useFetch(configHelper.PDA_API);
const { showNotification } = useNotifications();
const i18n = useI18n();
const dropdownOpen = ref(false);
const downloads = ref<(SimpleDownload | ComplexDownload)[]>();
const imageLoaded = ref(false);



/** Search params the downloads endpoint accepts, everything else results in a 400 */
const downloadListParams = ['downloadTyp', 'language', 'region'];

watch(dropdownOpen, async (newValue) => {
  if (newValue)
    try {
      const currentParams = route.query;
      const params = new URLSearchParams();

      // The endpoint rejects everything it does not know, so only the params it accepts are
      // forwarded. All other search filters narrow down the articles, not their downloads.
      Object.entries(currentParams).forEach(([key, value]) => {
        if (downloadListParams.includes(key)) params.append(key, value?.toString() || '');
      });

      const response = await fetchApi<DownloadListResponse>(
        `/articles/${props.product.year}/${props.product.articleId}/downloads?${params.toString()}`,
        {
          useCredentials: true,
        },
      );

      const downloadsList: (SimpleDownload | ComplexDownload)[] = [];

      response.complex.forEach((download) => downloadsList.push(download));
      response.simple.forEach((download) => downloadsList.push(download));

      downloads.value = downloadsList;
    } catch (error) {
      console.log(error);
      showNotification(i18n.t('genericError') + i18n.t('loadingDownloadsError'), 'error');
      downloads.value = undefined;
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("article", {
      class: "grid grid--cols-12 theme-light theme-light--8 dropdownProduct__head",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (dropdownOpen.value = !dropdownOpen.value)),
      onKeydown: _cache[2] || (_cache[2] = ($event: any) => (dropdownOpen.value = !dropdownOpen.value))
    }, [
      _createElementVNode("figure", _hoisted_1, [
        (!imageLoaded.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(Spinner)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("img", {
          class: _normalizeClass([{ 'dropdownProduct__image--loading': !imageLoaded.value }]),
          alt: `${_ctx.$t('productImage')} ${__props.product.articleId}`,
          src: 
            __props.product.image
              ? `${_unref(configHelper).PDA_API}/images/${__props.product.year}/${__props.product.image}`
              : '/placeholder.jpg'
          ,
          loading: "lazy",
          onLoad: _cache[0] || (_cache[0] = ($event: any) => (imageLoaded.value = true))
        }, null, 42, _hoisted_3)
      ]),
      _createElementVNode("section", _hoisted_4, [
        (__props.product.type === 'article' || __props.product.type === 'articleUS')
          ? (_openBlock(), _createBlock(ArticleDetails, {
              key: 0,
              article: __props.product
            }, null, 8, ["article"]))
          : (__props.product.type === 'accessory' || __props.product.type === 'accessoryUS')
            ? (_openBlock(), _createBlock(AccessoryDetails, {
                key: 1,
                accessory: __props.product
              }, null, 8, ["accessory"]))
            : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", {
          class: _normalizeClass(dropdownOpen.value ? 'newicon-40-1' : 'newicon-39-1')
        }, null, 2)
      ])
    ], 32),
    (dropdownOpen.value && downloads.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(ResultTable, {
            id: __props.product.articleId,
            items: downloads.value,
            year: __props.product.year
          }, null, 8, ["id", "items", "year"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})